import React from 'react';
import * as Sift from '@sift/types';

// Components
import { SortableContainer } from 'react-sortable-hoc';
import SortableItemElem from './SortableItemElem';

interface LayoutItem {
  type: 'field' | 'category';
  name: string;
}

type Layout = LayoutItem[];

interface LayoutValue {
  oldIndex: number;
  newIndex: number;
}

// Sortable HOCs
interface SortableListProps {
  layout: Layout;
  onRemoveItem?: (index: number) => void;
  onLayoutChange: (value: LayoutValue) => void;
  fields: Sift.Field[];
  classes: any;
}

const SortableList = SortableContainer(
  ({ layout, onLayoutChange, onRemoveItem, fields }: SortableListProps) => {
    return (
      <div>
        {layout.map((item: LayoutItem, index: number) => {
          const handleRemoveItem = !!onRemoveItem ? () => onRemoveItem(index) : undefined;
          return (
            <SortableItemElem
              key={item.name + index}
              index={index}
              itemIndex={index}
              onLayoutChange={onLayoutChange}
              layout={layout}
              value={item}
              fields={fields}
              onRemoveItem={handleRemoveItem}
            />
          );
        })}
      </div>
    );
  },
);

export default SortableList;
